import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BaseAsyncValue } from '@ordersnproducts/modules/shared/models/async-value';
import { getOneClickSelectedOrder } from '@ordersnproducts/modules/one-click-order/selectors/one-click-orders.selector';
import { jobsitesWithPreload } from '@ordersnproducts/modules/one-click-order/selectors/one-click-jobsites.selector';

export namespace OneClickDeliveryMethodProvider {
  export class TextPreview extends BaseAsyncValue<string> {
    getValue(): Observable<string> {
      return this.store.select(getOneClickSelectedOrder).pipe(
        filter(order => !!order),
        map(
          order => `${order && order.shippingCondition && order.shippingCondition.shippingConditionDesc.toLowerCase()}`,
        ),
      );
    }
  }

  export class TextBuilder extends BaseAsyncValue<string> {
    getValue(): Observable<string> {
      return this.store.select(jobsitesWithPreload).pipe(
        filter(({ preloadedOrder }) => !!preloadedOrder),
        map(({ preloadedOrder }) => `${preloadedOrder.shippingCondition.shippingConditionDesc.toLowerCase()}`),
      );
    }
  }
}
